<ng-container *ngIf="hasActiveBanner">
  <goab-notification class="notification-body" [class]="bannerType" [type]="bannerType">
    <span [innerHTML]="formattedBannerMessage"></span>
  </goab-notification>
</ng-container>
